/* eslint-disable ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class IndexRoute extends Route {
  // Services
  @service
  router;

  @service
  store;

  model() {
    return hash({
      subjects: this.store.findAll('goals/subject'),
      usageSets: this.store.findAll('schools/usage-set'),
      schools: this.store.findAll('school'),
      schoolGroups: this.store.findAll('schools/group'),
    });
  }

  activate() {
    super.activate(...arguments);
    if (this.onRouteDidChange) {
      this.router.off('routeDidChange', this.onRouteDidChange);
    }
    this.onRouteDidChange = () => {
      // Set activeSubject on the controller so that it can highlight the correct button.
      let subjectId = this.paramsFor('goals.subject').subject_id;
      this.controller.set('activeSubject', subjectId);
    };
    this.router.on('routeDidChange', this.onRouteDidChange);
  }

  deactivate() {
    super.deactivate(...arguments);
    if (this.onRouteDidChange) {
      this.router.off('routeDidChange', this.onRouteDidChange);
      this.onRouteDidChange = null;
    }
  }
}
